import { buildLoader } from '../util/GenericLoader';
import { fetchTotpActionCreator, fetchFido2ActionCreator } from '../../redux/actions/mfa';

export const TotpLoader = buildLoader(() => fetchTotpActionCreator(true));

export const Fido2Loader = buildLoader(() => fetchFido2ActionCreator(true));
